import * as types from '../constants/idpAdminActions';
import {getIdpMetadataApi, getOidcIdpMetadataApi} from "../api/api";
import * as messages from '../shared/messages';
import {GET} from "../constants/postMessages";
import {OIDC} from "../constants/requiredCapabilitiesMapping";
import {getMappedCapabilities} from "./storage";

export const getIdpMetadataStart = () => ({
  type: types.GET_IDP_METADATA_START
});
export const getIdpMetadataSuccess = (idpMetadata) => ({
  type: types.GET_IDP_METADATA_SUCCESS,
  idpMetadata,
});
export const getIdpMetadataFail = (errorMsg) => ({
  type: types.GET_IDP_METADATA_FAIL,
  errorMsg,
});

export function getIdpMetadata(appId) {
  const capabilities = JSON.parse(getMappedCapabilities());
  const getOidcMetadata = capabilities ? capabilities[OIDC] : false;
  return (dispatch) => {
    dispatch(getIdpMetadataStart());
    return getIdpMetadataApi(appId)
    .then(response => {
      dispatch(getIdpMetadataSuccess(response));
      if (getOidcMetadata) {
        dispatch(getOidcIdpMetadata(response.oidcIssuerUrl));
      }
    })
    .catch((error) => {
      dispatch(getIdpMetadataFail(error.message));
    });
  }
}

export function downloadIdpMetadataXml() {
  return (dispatch, getState) => {
    dispatch(getIdpMetadata())
    .then(() => {
      let metadataFileUrl = getState().idp.issuerUrl + "?file";
      let xhttp = new XMLHttpRequest();
      xhttp.open(GET, metadataFileUrl, false);
      xhttp.send();
      document.location.href = metadataFileUrl;
    })
    .catch(e => {
      dispatch(getIdpMetadataFail(messages.GENERIC_ERROR));
    });
  }
}

export const showIdpMetadataPopupConst = () => ({
  type: types.SHOW_IDP_METADATA_POPUP,
});
export const hideIdpMetadataPopupConst = () => ({
  type: types.HIDE_IDP_METADATA_POPUP,
});

export function showIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(showIdpMetadataPopupConst());
}

export function hideIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(hideIdpMetadataPopupConst());
}

export const getOidcIdpMetadataStart = () => ({
  type: types.GET_OIDC_IDP_METADATA_START
});
export const getOidcIdpMetadataSuccess = (oidcIdpMetadata) => ({
  type: types.GET_OIDC_IDP_METADATA_SUCCESS,
  oidcIdpMetadata,
});
export const getOidcIdpMetadataFail = (errorMsg) => ({
  type: types.GET_OIDC_IDP_METADATA_FAIL,
  errorMsg,
});

export function getOidcIdpMetadata(oidcIdpMetadataUrl) {
  return (dispatch) => {
    dispatch(getOidcIdpMetadataStart());
    return getOidcIdpMetadataApi(oidcIdpMetadataUrl)
      .then(response => {
        dispatch(getOidcIdpMetadataSuccess(response));
      })
      .catch((error) => {
        dispatch(getOidcIdpMetadataFail(error.message));
      });
  }
}

export const showOidcIdpMetadataPopupConst = () => ({
  type: types.SHOW_OIDC_IDP_METADATA_POPUP,
});
export const hideOidcIdpMetadataPopupConst = () => ({
  type: types.HIDE_OIDC_IDP_METADATA_POPUP,
});

export function showOidcIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(showOidcIdpMetadataPopupConst());
}

export function hideOidcIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(hideOidcIdpMetadataPopupConst());
}


// WEBPACK FOOTER //
// ./src/actions/idp.js